/* =================== COMPLETA ENDEREÇO =================== */
jQuery(document).ready(function ($) {
  $(".cep_completa").on("change", function () {
    var input = $(this);
    var cep = $(this).val();
    var url = $(this).data("url");
    var loading = input.prev(".campo-loading");

    $.ajax({
      url: url,
      type: "POST",
      data: {
        cep: cep,
      },
      beforeSend: function () {
        loading.fadeIn();
        input.prop("disabled", true);
      },
      success: function (data) {
        console.log(data);
        loading.fadeOut();
        input.prop("disabled", false);
        try {
          var endereco = JSON.parse(data);

          $("#logradouro").val(endereco.logradouro);
          $("#bairro").val(endereco.bairro);
          $("#cidade").val(endereco.cidade);
          $("#estado").val(endereco.uf);
          $("#numero").focus();

          $("#logradouro").parsley().validate();
          $("#bairro").parsley().validate();
          $("#cidade").parsley().validate();
          $("#estado").parsley().validate();
        } catch (e) {
          return false;
        }
      },
      error: function (xhr, type, exception) {
        loading.fadeOut();
        input.prop("disabled", false);
        console.log("ajax error response type " + type);
      },
    });
  });
});

/* =================== COMPLETA ENDEREÇO (CADASTRO DO ANÚNCIO) =================== */
jQuery(document).ready(function ($) {
  $(".cep_completa_cad").on("change", function () {
    var input = $(this);
    var cep = $(this).val();
    var url = $(this).data("url");
    var loading = input.prev(".campo-loading");

    $.ajax({
      url: url,
      type: "POST",
      data: {
        cep: cep,
      },
      beforeSend: function () {
        loading.fadeIn();
        input.prop("disabled", true);
      },
      success: function (data) {
        //console.log(data);
        loading.fadeOut();
        input.prop("disabled", false);
        try {
          var endereco = JSON.parse(data);
          console.log(endereco);

          $("#logradouro").val(endereco.logradouro);
          $("#bairro").val(endereco.bairro);
          $("#estado_id").val(endereco.estado_id);
          $("#estado_id").trigger("change");
          $("#cidade_id").data("sync-value", endereco.cidade_id);
          $("#numero").focus();

          $("#logradouro").parsley().validate();
          $("#bairro").parsley().validate();
          $("#estado_id").parsley().validate();
        } catch (e) {
          return false;
        }
      },
      error: function (xhr, type, exception) {
        loading.fadeOut();
        input.prop("disabled", false);
        console.log("ajax error response type " + type);
      },
    });
  });
  $("#form-anuncio #estado_id").on("change", function () {
    $("#estado_nome").val($(this).find("option:selected").text());
  });
  $("#form-anuncio #cidade_id").on("change", function () {
    $("#cidade_nome").val($(this).find("option:selected").text());
  });
});
